export default __webpack_public_path__ + "98a2dd8cb0de7095eec1570ee804afcc.png";